import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'itl-lightbox',
  templateUrl: './lightbox.modal.html',
  styleUrls: ['./lightbox.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LightboxModal implements OnInit {
  @ViewChild('slides', { static: true }) slides: IonSlides;

  @Input()
  public images = [];
  @Input()
  public currentIndex = 0;
  public isAndroid: boolean;
  public version: number;

  public get isIos() {
    return this._platform.is('ios');
  }

  constructor(public _modalCtrl: ModalController, private _platform: Platform) {}

  async ngOnInit() {
    await this.slides.update();
    await this.slides.slideTo(this.currentIndex);
  }

  public async slideChanged() {
    const currentIndex = await this.slides.getActiveIndex();
    if (currentIndex < this.images.length) {
      this.currentIndex = currentIndex;
    }
  }
}
